/* eslint-disable @typescript-eslint/naming-convention */
import type { Func } from "@react-awesome-query-builder/core";

const UNIFIED_WEEKS_BETWEEN: Func = {
  label: "WEEKS TILL DATE",
  returnType: "number",

  // Custom jsonLogic builder
  jsonLogic: (args) => ({
    UNIFIED_WEEKS_BETWEEN: [
      args.date, // user-selected value / field / func
      { var: "Start_Unified_Sync_Time" }, // injected field
    ],
  }),

  sqlFunc: "UNIFIED_WEEKS_BETWEEN",

  args: {
    date: {
      label: "From Date",
      type: "date",
      valueSources: ["value", "field", "func"],
    },
  },

  formatFunc: (formattedArgs) =>
    `UNIFIED_WEEKS_BETWEEN(${formattedArgs.date}, Start_Unified_Sync_Time)`,

  sqlFormatFunc: (formattedArgs) =>
    `UNIFIED_WEEKS_BETWEEN(${formattedArgs.date}, Start_Unified_Sync_Time)`,
};

export default UNIFIED_WEEKS_BETWEEN;
